export type OrganizationPageProps = {
  organizationId: string;
};

export const OrganizationPage = ({ organizationId }: OrganizationPageProps) => {
  return <div>Organization page</div>;
};
